import { render } from "./Help.vue?vue&type=template&id=41d1c286&scoped=true"
import script from "./Help.vue?vue&type=script&lang=js"
export * from "./Help.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-41d1c286"

export default script